import React from 'react';
var ListTableContext = React.createContext({});
export default ListTableContext;
